






























































































import { Vue, Component, Prop } from 'vue-property-decorator'
import type {
  LibraryCategory,
  LibraryCategoryArticle,
  LibrarySubcategory
} from '~/domains/library/Library.types'

import BBLazyBackground from '~/components/BB/BBLazyBackground.vue'
import BBLazy from '~/components/BB/BBLazy.vue'

@Component({
  components: { BBLazy, BBLazyBackground }
})
export default class BrandingCategory extends Vue {
  @Prop({
    type: Object
  })
  category: LibraryCategory

  @Prop({
    type: Object
  })
  subcategory: LibrarySubcategory

  @Prop({
    type: Array,
    default: () => []
  })
  breadcrumbs: {
    text: string
    to: string
  }[]

  @Prop({
    type: Array,
    default: () => []
  })
  articles: LibraryCategoryArticle[]

  get headerTextColor () {
    return this.subcategory.brand?.headerColor || '#fff'
  }
}
